


/*

to use coreui icons use "icon" property

                name: 'Home',
                to: `/home`,
                icon: 'cil-home',

to use fontawsome use class
 to: `/role/${tenant.value.code}`,
class: 'fa fa-cog',

 */

export default function () {

    return [
        {
            component: 'CNavItem',
            name: 'Home',
            to: `/home`,
            icon: 'cil-home',
            badge: {
                variant: 'primary',
            }
        },
        
      
        
        {
            name: 'Dashboard',
            to: `/dashboard/:tenant`,
            id: 'dashboard',
            icon: 'cil-chart',
            badge: {
                variant: 'primary',
            }
        },
        {
            component: 'CNavItem',
            name: 'Launcher',
            id: 'searchapp',
            to: `/searchapp/:tenant`,
            class: 'fa fa-rocket'
        },
        {
            component: 'CNavGroup',
            name: 'Application',
            to: ``,
            expand: false,

            icon: 'cib-circleci',
            badge: {
                variant: 'primary',
            },
            items: [

                {
                    component: 'CNavItem',
                    name: 'Search',
                    id: 'search',
                    to: `/search/search/:tenant`,
                    exact:false,
                    icon: 'cil-search'
                },
                {
                    component: 'CNavItem',
                    name: 'Category',
                    id: 'category',
                    to: `/search/category/:tenant`,
                    exact:false,
                    icon: 'cil-playlist-add'
                },
                {
                    component: 'CNavItem',
                    name: 'Suggest',
                    id: 'suggest',
                    to: `/search/suggest/:tenant`,
                    baseUrl: '/search/suggest',
                    icon: 'cil-speech'
                },

                {
                    component: 'CNavItem',
                    name: 'Synonyms',
                    id: 'synonym',
                    to: `/search/synonym/:tenant`,
                    exact:false,
                    icon: 'cil-book'
                },
                {
                    component: 'CNavItem',
                    name: 'Redirects',
                    id: 'redirect',
                    to: `/search/redirect/:tenant`,
                    exact:false,
                    icon: 'cil-arrow-thick-from-left'
                },
            ]
        },

        {
            component: 'CNavItem',
            name: 'Feeding',
            id: 'feeding',
            to: `/feeding/:tenant`,
            icon: 'cil-speedometer',
            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'System Monitoring',
            id: 'system-monitoring',
            to: `/monitoring/system-monitoring/:tenant`,
            baseUrl: '/monitoring/system-monitoring',
            class: 'fa fa-video-camera',
            description: 'Monitor your web pages with java script',
        },
        {
            component: 'CNavGroup',
            name: 'Index',
            to: ``,
            parentId: 'index-storage',
            expand: false,
            class:'fa fa-database',
            badge: {
                variant: 'secondary',
            },
            items: [
                {
                    component: 'CNavItem',
                    name: 'Index',
                    id: 'index-storage',
                    baseUrl: '/index/index-storage',
                    to: `/index/index-storage/:tenant`,
                    class:'fa fa-database'
                },
                {
                    component: 'CNavItem',
                    name: 'Analyzer',
                    id: 'analyzer',
                    to: `/index/analyzer/:tenant`,
                    baseUrl: '/index/analyzer',
                    class:'fa fa-language'
                },
                {
                    component: 'CNavItem',
                    name: 'Vectorizer',
                    id: 'vectorizer',
                    to: `/index/vectorizer/:tenant`,
                    baseUrl: '/index/vectorizer',
                    class:'fa fa-newspaper'
                },
            ]
        },
        {
            component: 'CNavItem',
            name: 'Generic Lists',
            id: 'list',
            to: `/list/:tenant`,
            icon: 'cil-list',
            badge: {
                variant: 'primary',
            }
        },
        {
            name: "Widget",
            component: "CNavItem",
            to: `/widget/:tenant`,
            class: "fa-solid fa-globe",
            id: "widget",
            badge: {
              variant: "primary",
            },
          },
        {
            name: 'Config',
            component: 'CNavItem',
            to: `/config/:tenant`,
            icon: 'cil-settings',
            id: 'config',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Assets',
            component: 'CNavItem',
            to: `/assets/:tenant`,
            icon: 'cil-settings',
            id: 'assets',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Text Extract',
            component: 'CNavItem',
            to: `/text-extract/:tenant`,
            icon: 'cil-settings',
            id: 'text-extract',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Alias',
            component: 'CNavItem',
            to: `/alias/:tenant`,
            icon: 'cil-settings',
            id: 'alias',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Monitoring',
            component: 'CNavItem',
            to: `/monitoring/:tenant`,
            icon: 'cil-settings',
            id: 'monitoring',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Id Mapping',
            component: 'CNavItem',
            id: 'id-mapping',
            to: `/id-mapping/:tenant`,
            icon: 'cil-resize-width',

            badge: {
                variant: 'primary',
            }
        },
        {
            component: 'CNavItem',
            name: 'Api Testing',
            id: 'api-testing',
            to: `/api-testing/:tenant`,
            class: 'fa fa-check',
            expert: true
        },
        {
            name: 'User',
            id: 'user',
            to: `/user/:tenant`,
            class: 'fa fa-user',
            description: 'Manage your users',
            expert: true
        },
        {
            name: 'Tenant',
            id: 'tenant',
            component: 'CNavItem',
            to: `/tenant/:tenant`,
            icon: 'cil-user-plus',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Role',
            id: 'role',
            component: 'CNavItem',
            to: `/role/:tenant`,
            class: 'fa fa-user',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Schedule',
            id: 'schedule',
            component: 'CNavItem',
            to: `/schedule/:tenant`,
            class: 'fa fa-calendar',
            expert: true
        },
        {
            component: 'CNavItem',
            name: 'Security',
            id: 'security',
            to: `/security/:tenant`,
            class: 'fa fa-lock',
            expert: true
        },

        {
            name: 'Export Import',
            id: 'expimp',
            to: `/expimp/:tenant`,
            class: 'fa fa-download',
            expert: true
        },
        {
            name: 'Facet',
            id: 'facet',
            component: 'CNavItem',
            to: `/facet/:tenant`,
            icon: 'cil-filter',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Entity Manager',
            id: 'entityManager',
            onlyWithRawTabPermission: true,
            component: 'CNavItem',
            to: `/entity-manager/:tenant`,
            class: 'fa fa-wrench',

            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'ui-config Manager',
            id: 'componentConfigManager',
            onlyWithRawTabPermission: true,
            component: 'CNavItem',
            to: `/component-config-manager/:tenant`,
            class: 'fa fa-wrench',

            badge: {
                variant: 'primary',
            }
        }
    ]


}




